module.exports = __webpack_public_path__ + "static/section-img1@2x-6f6cb6ae5f65db4a904bbd9c8a3b0749.png";